exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gps[data-v-4a6d7a38] {\n  position: relative;\n  width: 100%;\n}\n", ""]);

// exports
